import ShuwaWallet from "../../components/business/ShuwaWallet";

/** The customer's own SHUWA wallet: added money and refunds, spent on bookings. */
export default function Wallet() {
  return (
    <div>
      <h1 className="mb-6 font-montserrat text-2xl font-bold text-slate-900">Wallet</h1>
      <ShuwaWallet customer />
    </div>
  );
}
